"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInfo = void 0;
const Point2D_1 = require("../../graphics2d/Point2D");
const Rectangle2D_1 = require("../../graphics2d/Rectangle2D");
const RendererSettings_1 = require("../../renderer/utilities/RendererSettings");
const ShapeUtilities_1 = require("../../renderer/utilities/ShapeUtilities");
const RectUtilities_1 = require("./RectUtilities");
const canvas_1 = require("canvas");
/**
 *
 *
 */
class TextInfo {
    _text = "";
    _location;
    _bounds;
    _descent = 0;
    _aboveBaseHeight = 0;
    isNode = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
    isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
    OSCDefined = typeof OffscreenCanvasRenderingContext2D !== 'undefined'; //web workers fail isBrowser test
    OSCanvasDefined = typeof OffscreenCanvas !== 'undefined'; //web workers fail isBrowser test
    constructor(text, x, y, font, context) {
        let ctx; //OffscreenCanvasRenderingContext2D | CanvasRenderingContext2D;
        let tm; //node-canvas doesn't fully implement TextMetics so must set to any
        let top;
        let left;
        let width;
        let height;
        let bounds;
        if (context == null) {
            let osc;
            if (this.OSCDefined)
                osc = new OffscreenCanvas(10, 10);
            else
                osc = (0, canvas_1.createCanvas)(10, 10);
            ctx = osc.getContext("2d");
        }
        else {
            ctx = context;
        }
        if (typeof font === 'string')
            ctx.font = font;
        else
            ctx.font = font.toString();
        this._text = text;
        tm = ctx.measureText(text);
        if (tm.fontBoundingBoxAscent != null)
            top = y - tm.fontBoundingBoxAscent;
        else {
            top = y - tm.emHeightAscent;
        }
        left = x;
        this._location = new Point2D_1.Point2D(x, y);
        width = tm.width;
        width = tm.actualBoundingBoxRight + tm.actualBoundingBoxLeft;
        if (this.OSCDefined) {
            height = tm.fontBoundingBoxDescent + tm.fontBoundingBoxAscent;
            this._descent = tm.fontBoundingBoxDescent;
            this._aboveBaseHeight = tm.fontBoundingBoxAscent;
        }
        else {
            height = tm.emHeightDescent + tm.emHeightAscent;
            this._descent = tm.emHeightDescent;
            this._aboveBaseHeight = tm.emHeightAscent;
        }
        bounds = new Rectangle2D_1.Rectangle2D(top, left, width, height);
        RectUtilities_1.RectUtilities.grow(bounds, 1);
        this._bounds = bounds;
        /*console.log(this._text);
        console.log(this._bounds);
        console.log(tm);//*/
    }
    setLocation(x, y) {
        this._bounds.setRect(x, y - this._aboveBaseHeight, this._bounds.getWidth(), this._bounds.getHeight());
        RectUtilities_1.RectUtilities.grow(this._bounds, 1);
        this._location.setLocation(x, y);
    }
    getLocation() {
        return this._location;
    }
    shift(x, y) {
        ShapeUtilities_1.ShapeUtilities.offset(this._bounds, x, y);
        ShapeUtilities_1.ShapeUtilities.offset(this._location, x, y);
    }
    getText() {
        return this._text;
    }
    /**
     * includes the descent
     * @returns
     */
    getTextBounds() {
        return this._bounds;
    }
    getTextOutlineBounds() {
        let RS = RendererSettings_1.RendererSettings.getInstance();
        let outlineOffset = RS.getTextOutlineWidth();
        let bounds = this._bounds.clone();
        if (outlineOffset > 0) {
            if (RS.getTextBackgroundMethod() === RendererSettings_1.RendererSettings.TextBackgroundMethod_OUTLINE) {
                ShapeUtilities_1.ShapeUtilities.grow(bounds, outlineOffset / 2);
            }
            else {
                ShapeUtilities_1.ShapeUtilities.grow(bounds, outlineOffset);
            }
        }
        return bounds;
    }
    getDescent() {
        return this._descent;
    }
    strokeText = function (context) {
        context.strokeText(this.text, this.location.getX(), this.location.getY());
    };
    fillText = function (context) {
        context.fillText(this.text, this.location.getX(), this.location.getY());
    };
}
exports.TextInfo = TextInfo;
//# sourceMappingURL=TextInfo.js.map